<template>
  <BModal
    id="modal-confirm-billing"
    hide-footer
    hide-header
    :centered="true"
    content-class="rounded-lg"
  >
    <div class="text-center p-1">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Konfirmasi"
        class="mx-auto"
        width="80px"
      >
      <div class="font-semibold text-[18px] text-[#333333] my-2">
        {{ titleText }}
      </div>
      <div class="mb-2">
        <p class="text-[#626262]">
          {{ bodyText }}
        </p>
      </div>

      <div class="flex flex-row gap-4">
        <BButton
          variant="outline-primary"
          class="rounded grow"
          :disabled="processing"
          @click="$bvModal.hide('modal-confirm-billing')"
        >
          Batal
        </BButton>

        <BButton
          variant="primary"
          class="rounded grow"
          :disabled="processing"
          @click="onConfirm"
        >
          <BSpinner
            v-if="processing"
            small
            class="mr-1"
          />
          {{ confirmLabel }}
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue'

export default {
  name: 'ModalConfirmBilling',
  components: {
    BModal,
    BButton,
    BSpinner,
  },
  props: {
    /**
     * Action mode to confirm.
     * - 'setup' will confirm submitting billing setup changes.
     * - 'turn_off' will confirm turning off billing.
     */
    mode: {
      type: String,
      required: true,
      validator: v => ['setup', 'turn_off'].includes(v),
    },
    /** Platform code: 'meta' | 'google' | 'tiktok' */
    platform: {
      type: String,
      required: true,
      validator: v => ['meta', 'google', 'tiktok'].includes(v),
    },
    /**
     * When true, disables buttons and shows loading indicator on confirm button.
     */
    processing: {
      type: Boolean,
      default: false,
    },
    /**
     * Optional custom title override.
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Optional custom body text override.
     */
    message: {
      type: String,
      default: '',
    },
  },
  computed: {
    /** Display name mapping for platform codes */
    platformName() {
      const map = { meta: 'Meta', google: 'Google', tiktok: 'TikTok' }
      return map[this.platform] || this.platform
    },
    /** Title text shown on the modal header */
    titleText() {
      if (this.title) return this.title
      return this.mode === 'setup'
        ? 'Konfirmasi Perubahan Biaya Langganan'
        : 'Konfirmasi Nonaktifkan Langganan'
    },
    /** Body confirmation message */
    bodyText() {
      if (this.message) return this.message
      return this.mode === 'setup'
        ? `Apakah kamu yakin ingin mengubah biaya langganan platform ${this.platformName}?`
        : `Apakah kamu yakin ingin menonaktifkan biaya langganan platform ${this.platformName}?`
    },
    /** Label for the primary action button */
    confirmLabel() {
      return this.mode === 'setup' ? 'Ya, Ubah' : 'Nonaktifkan'
    },
  },
  methods: {
    /**
     * Emit confirmation event to parent.
     * Parent is responsible for executing API calls and handling success/error.
     * @returns {void}
     */
    onConfirm() {
      this.$emit('confirm-billing', { mode: this.mode, platform_name: this.platform })
    },
  },
}
</script>
